import { defineMessages } from "@formatjs/intl";
import { IContext } from "@src/context";
import "./index.css";

export const noPropertiesMessage = defineMessages({
  empty: {
    id: "Element.NoProperties.empty",
    defaultMessage: "No Properties Found",
  },
});

export function getNoPropertiesHtml(
  intl: IContext["intl"] | undefined,
  ...classNames: string[]
) {
  const word = intl
    ? intl.formatMessage(noPropertiesMessage.empty)
    : noPropertiesMessage.empty.defaultMessage;
  const classNameGroup = classNames.join(" ");
  return `<li class="element-no-properties ${classNameGroup}"><span class="h4">${word}</span></li>`;
}
